import React from 'react';
import { useTranslation } from 'react-i18next';

function FirstAndLastBalls({ numbers }: Readonly<{ numbers: number[] }>) {
    const { t } = useTranslation();
    const halfNumbersLength = Math.ceil(numbers.length / 2);
    const firstNumbers = numbers.slice(0, halfNumbersLength);
    const lastNumbers = numbers.slice(halfNumbersLength);
    const labelClasses = 'position-absolute z-1 mt-n3 mt-sm-n2 text-capitalize bg-primary text-white px-3 py-1 small';

    return (
        <>
            <div className="row font-black row-balls">
                <div className={labelClasses}>{t('results.balls.first')}</div>
                {firstNumbers.map((number, index) => (
                    <div key={`first-${index}`} className="results-ball ball-bg ball-main ball-0">
                        {number}
                    </div>
                ))}
            </div>
            <div className="row font-black row-balls">
                <div className={labelClasses}>{t('results.balls.last')}</div>
                {lastNumbers.map((number, index) => (
                    <div key={`last-${index}`} className="results-ball ball-bg ball-main ball-0">
                        {number}
                    </div>
                ))}
            </div>
        </>
    );
}

export default FirstAndLastBalls;
